<img class="robot" src="assets/img/curious-robot.svg" alt="curious robot" width="185" height="227" />
<ng-content select=".title"></ng-content>
<ng-content select=".description"></ng-content>
